import React from "react";
import "./PDFViewer.css";

export default function PDFViewer({ onClose }) {
  return (
    <div className="pdf-viewer-overlay" onClick={onClose}>
      <div className="pdf-viewer-window" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-viewer-topbar">
          <div className="pdf-viewer-buttons">
            <span className="close" onClick={onClose}></span>
            <span className="minimize"></span>
            <span className="maximize"></span>
          </div>
          <span className="pdf-viewer-title">CV_Karel_Berrehouc.pdf</span>
        </div>
        <div className="pdf-viewer-content">
          <iframe 
            src="cv.pdf" 
            title="CV PDF"
            width="100%" 
            height="100%"
          />
        </div>
      </div>
    </div>
  );
}
